import {fromJS} from 'immutable';
import * as walletActions from './walletActions';


const defaultState = fromJS({
  connected: false,
  loaded: false,
  identity: null,
  connection: null,
  account: null,
  transaction_message: {},
  restApi: {}
});

export default function reducer(state = defaultState, action) {
  const {payload} = action;

  switch (action.type) {
    case walletActions.getMessagesRoutine.TRIGGER: {
      return state;
    }

    case walletActions.getMessagesRoutine.SUCCESS: {
      const newState = state.set('messages', fromJS(payload));
      return newState;
    }

    case walletActions.getMessagesRoutine.FAILURE: {
      return state;
    }

    case walletActions.connectToWalletRoutine.TRIGGER: {
      return state;
    }

    case walletActions.connectToWalletRoutine.SUCCESS: {
      const newState = state.set('connection', fromJS(payload));
      return newState;
    }

    case walletActions.connectToWalletRoutine.FAILURE: {
      console.error('Failed to connect to Wallet');
      return state;
    }

    //Yolo TokenSwap
    case walletActions.tokenSwapRoutine.TRIGGER: {
      return state;
    }
    //Yolo TokenSwap
    case walletActions.tokenSwapRoutine.SUCCESS: {
      const yoloIframe = document.getElementById('yolo');
      yoloIframe && yoloIframe.contentWindow.postMessage(JSON.stringify({
        action: "transaction",
        data: {
          broadcast: true,
          transaction_id: payload.id,
        }
      }), "https://yoloswap.com/widget");
      return state;
    }
    //Yolo TokenSwap
    case walletActions.tokenSwapRoutine.FAILURE: {
      const yoloIframe = document.getElementById('yolo');
      yoloIframe && yoloIframe.contentWindow.postMessage(JSON.stringify({
        action: "transaction",
        data: {
          code: 500,
          error: {
            code: 3090004,
            details: [{
              message: payload.message
            }],
            name: 'error_message',
            what: payload.message
          },
          message: payload.message
        }
      }), "https://yoloswap.com/widget");
      return state;
    }

    case walletActions.signInToWalletRoutine.TRIGGER: {
      return state;
    }

    case walletActions.signInToWalletRoutine.SUCCESS: {
      const tempState = state.set('identity', fromJS(payload.accountRows));
      const account = payload.accountRows.account_name;
      const newState = tempState.set('account', fromJS(account));
      return newState;
    }

    case walletActions.signInToWalletRoutine.FAILURE: {
      return state;
    }

    case walletActions.signOutOfWalletRoutine.TRIGGER: {
      return state;
    }

    case walletActions.signOutOfWalletRoutine.SUCCESS: {
      const newState = fromJS({
        connected: false,
        loaded: false,
        identity: null,
        connection: null,
        account: null,
      });
      return newState;
    }

    case walletActions.signOutOfWalletRoutine.FAILURE: {
      return state;
    }

    case walletActions.getAccountBalancesRoutine.TRIGGER: {
      return state;
    }

    case walletActions.getAccountBalancesRoutine.SUCCESS: {
      const newState = state.set('accountInfo', fromJS(payload));
      return newState;
    }

    case walletActions.getAccountBalancesRoutine.FAILURE: {
      return state;
    }

    case walletActions.dataLoadedRoutine.TRIGGER: {
      return state;
    }

    case walletActions.dataLoadedRoutine.SUCCESS: {
      const dataLoaded = state.set('loaded', true);
      return dataLoaded;
    }

    case walletActions.dataLoadedRoutine.FAILURE: {
      return state;
    }

    case walletActions.connectedRoutine.TRIGGER: {
      return state;
    }

    case walletActions.connectedRoutine.SUCCESS: {
      const connectChange = state.set('connected', true);
      return connectChange;
    }

    case walletActions.connectedRoutine.FAILURE: {
      return state;
    }

    case walletActions.restApiRoutine.TRIGGER: {
      return state;
    }

    case walletActions.restApiRoutine.SUCCESS: {
      const newState = state.set('restApi', fromJS(payload));
      return newState;
    }

    case walletActions.restApiRoutine.FAILURE: {
      return state;
    }

    default:
      return state;
  }
}